angular
	.module 'App.Module.Documentation', []
	.config ($stateProvider) ->
		$stateProvider
			.state 'documentation',
				url: '/documentation',
				views:
					main:
						templateUrl: '@app/documentation/documentation.view.html'
						controllerAs: 'documentation'
						controller: 'DocumentationController'
				data:
					require_login: false
					hideMenu: true
					hideSubMenu: true
					showFooter: false
